import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	cornerStyle: {
		id: 'custom-sites-extensions.links-menu.corner.style',
		defaultMessage: 'Corner style',
		description: 'Text labeling a customization option for corner styling',
	},
	roundCornerStyleLabel: {
		id: 'custom-sites-extensions.links-menu.corner.style-round',
		defaultMessage: 'Round',
		description: 'Tooltip and label text label describing the round corner styling option',
	},
	squareCornerStyleLabel: {
		id: 'custom-sites-extensions.links-menu.corner.style-square',
		defaultMessage: 'Square',
		description: 'Tooltip and label text describing the square corner styling option',
	},
});
